export default __webpack_public_path__ + "static/media/alt_isveren_calisan_sayisi_ornek_excel.b9f6afe6.xlsx";